<template>
    <b-popover :target="'popover-target-js_' + matchData.matchId" triggers="hover" no-fade placement="right">

        <template #title>
            <div class="d-flex justify-content-center align-items-center text-center mt-5">
                <div class="d-flex align-items-center ">
                    <h6 class="font-weight-bolder text-white">{{ matchData.teams1 }}</h6>
                    <b-avatar size="sm" class="me-10 ms-10" rounded
                        :src="`http://lcsjfx.com/football/${matchData.homeImg}`" />
                </div>
                <div class="me-10 fs-20 text-success " style="margin-top: -5px;">
                    {{ matchData.nowscore.split('-')[0] }}
                    - {{ matchData.nowscore.split('-')[1] }}</div>
                <div class="d-flex align-items-center">
                    <b-avatar size="sm" class="me-10" rounded
                        :src="`http://lcsjfx.com/football/${matchData.guestImg}`" />
                    <div class="mr-20 text-left ">
                        <h6 class="font-weight-bolder text-white">{{ matchData.teams2 }}</h6>
                    </div>
                </div>
            </div>
        </template>
        <template #default>
            <div class="table-responsive">
                <table class="table  table-sm text-center text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" colspan="3">技术统计</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td :class="tdClass" >
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>{{ matchData.matchModel.jscs11 }}</div>
                                    <div :class="tpClass" style="transform: scaleX(-1)"><b-progress max="150"
                                            :value="matchData.matchModel.jscs11" height="10px"
                                            class="progress-bar-danger " />
                                    </div>
                                </div>
                            </td>
                            <th scope="row">危险进攻数</th>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div :class="tpClass"><b-progress max="150" :value="matchData.matchModel.jscs12"
                                            height="10px" class=" progress-bar-info" />
                                    </div>
                                    <div>{{ matchData.matchModel.jscs12 }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>{{ matchData.matchModel.jscs21 }}</div>
                                    <div :class="tpClass" style="transform: scaleX(-1)"><b-progress max="50"
                                            :value="matchData.matchModel.jscs21" height="10px"
                                            class="progress-bar-danger " />
                                    </div>
                                </div>
                            </td>
                            <th scope="row">射门数</th>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div :class="tpClass"><b-progress max="50" :value="matchData.matchModel.jscs22"
                                            height="10px" class="w-20 progress-bar-info" />
                                    </div>
                                    <div>{{ matchData.matchModel.jscs22 }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>{{ matchData.matchModel.jscs31 }}</div>
                                    <div :class="tpClass" style="transform: scaleX(-1)"><b-progress max="30"
                                            :value="matchData.matchModel.jscs31" height="10px"
                                            class="progress-bar-danger " />
                                    </div>
                                </div>
                            </td>
                            <th scope="row">射正数</th>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div :class="tpClass"><b-progress max="30" :value="matchData.matchModel.jscs32"
                                            height="10px" class="w-20 progress-bar-info" />
                                    </div>
                                    <div>{{ matchData.matchModel.jscs32 }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>{{ matchData.matchModel.jscs51 }}</div>
                                    <div :class="tpClass" style="transform: scaleX(-1)"><b-progress max="100"
                                            :value="matchData.matchModel.jscs51" height="10px"
                                            class="progress-bar-danger " />
                                    </div>
                                </div>
                            </td>
                            <th scope="row">控球率</th>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div :class="tpClass"><b-progress max="100" :value="matchData.matchModel.jscs52"
                                            height="10px" class="w-20 progress-bar-info" />
                                    </div>
                                    <div>{{ matchData.matchModel.jscs52 }}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>{{ matchData.matchModel.jscs61 }}</div>
                                    <div :class="tpClass" style="transform: scaleX(-1)"><b-progress max="120"
                                            :value="matchData.matchModel.jscs61" height="10px"
                                            class="progress-bar-danger " />
                                    </div>
                                </div>
                            </td>
                            <th scope="row">进攻数</th>
                            <td :class="tdClass">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div :class="tpClass"><b-progress max="120" :value="matchData.matchModel.jscs62"
                                            height="10px" class="w-20 progress-bar-info" />
                                    </div>
                                    <div>{{ matchData.matchModel.jscs62 }}</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </template>
    </b-popover>
</template>
<script>
export default ({
    props: {
        matchData: {},
    },

    data() {
    return {
      ifMobile: false,
      tdClass : 'w-200',
      tpClass : 'w-130',
    }
  },

    computed: {


    },
    created() {
        if (window.innerWidth <= 768) {
            this.ifMobile = true;
            this.tdClass = 'w-50';
            this.tpClass = 'w-30';
        }
    },
})
</script>